export const ADD_SETTINGS_DATA = "ADD_SETTINGS_DATA";
export const ADD_GENERAL_SETTING_DATA = "ADD_GENERAL_SETTING_DATA";
export const SET_TIME_ZONE = "SET_TIME_ZONE";
